<template>
  <div>
    <div class="d-flex flex-row">
      <v-autocomplete
        :ref="'auto' + id"
        :loading="uploading"
        v-model="selectedFiles"
        :disabled="disabled"
        :items="internalFiles"
        :rules="rules"
        :label="label"
        return-object
        item-value="description"
        item-text="description"
        multiple
        @change="emitFiles($event)"
      >
        <v-list-item slot="prepend-item">
          <v-btn text @click="$refs['auto' + id].isMenuActive = false" small>
            {{ $t("globals.close") }}
          </v-btn>
        </v-list-item>
        <template v-slot:selection="data">
          <v-chip
            large
            v-bind="data.attrs"
            :input-value="data.selected"
            @click="data.select"
          >
            {{ data.item.description }}
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-container pa-0>
                  <v-row no-gutters class="test">
                    <v-col>
                      <v-icon
                        class="chip-btn"
                        @click="preview(data.item)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        visibility
                      </v-icon>
                    </v-col>
                  </v-row>
                </v-container>
              </template>
              <span>
                {{ $t("globals.preview") }}
              </span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-container pa-0>
                  <v-row no-gutters class="test">
                    <v-col>
                      <v-icon
                        class="chip-btn"
                        @click="download(data.item)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        file_download
                      </v-icon>
                    </v-col>
                  </v-row>
                </v-container>
              </template>
              <span>
                {{ $t("globals.download") }}
              </span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-container pa-0>
                  <v-row no-gutters class="test">
                    <v-col>
                      <v-icon
                        class="chip-btn"
                        @click="remove(data.item)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        cancel
                      </v-icon>
                    </v-col>
                  </v-row>
                </v-container>
              </template>
              <span>
                {{ $t("globals.remove") }}
              </span>
            </v-tooltip>
          </v-chip>
        </template>
        <template v-slot:item="data">
          <template>
            <v-list-item-content>
              <v-list-item-title
                v-html="data.item.description"
              ></v-list-item-title>
            </v-list-item-content>
          </template>
        </template>
      </v-autocomplete>
      <v-btn
        style="margin-top:15px"
        fab
        small
        color="primary"
        @click="onAddClick"
        :loading="uploading"
        :disabled="disabled"
      >
        <v-icon style="margin:0!important">add</v-icon>
      </v-btn>
      <input
        :id="id"
        multiple
        ref="uploader"
        style="display: none"
        type="file"
        @change="handleFileChange"
      />
    </div>
    <file-preview
      :fullScreen="false"
      v-if="showPreview"
      :view="showPreview"
      :fileItem="fileItem"
      @close="close"
    />
    <!-- <file-preview :view="showPreview" :file="previewFile" :pageCount="pageCount" :pdfSrc="src" :fileData="fileData" @close="close"/> -->
    <!-- <v-dialog persistent scrollable v-model="showPreview" max-width="480">
      <v-card>
        <v-container
          fluid
          grid-list-md
          v-if="fileItem === null || fileItem === undefined"
        >
          <v-layout row justify-center>
            <v-flex xs12 sm6 md4 lg3>
              <v-progress-circular indeterminate></v-progress-circular>
            </v-flex>
          </v-layout>
        </v-container>
        <div v-else-if="fileItem.ExtensionType.FileType === 'Adobe Reader'">
          <pdf
            v-for="page in pageCount"
            :key="page"
            id="pdfdiv"
            :src.sync="src"
            :page="page"
            class="centered-div"
            :style="'width: 100%;'"
          ></pdf>
        </div>
        <div
          v-else-if="fileItem.ExtensionType.FileType === 'Image'"
          class="file-preview-container"
        >
          <v-img ref="img" :src.sync="src"></v-img>
        </div>
        <div
          v-else-if="fileItem.ExtensionType.FileType === 'text'"
          class="file-preview-container"
          style="font-size:1em;overflow-y:auto"
        >
          {{ src }}
        </div>
        <v-card-text v-else class="file-preview-container">
          <h5>{{ $t("download_center.labels.no_preview") }}</h5>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="
              showPreview = false;
              fileItem = null;
            "
          >
            {{ $t("globals.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <v-dialog persistent scrollable v-model="fileExistsWarning" max-width="480">
      <material-card
        :title="$t('components.multifileupload2.file_exists_warning_title')"
        :color="$vuetify.theme.themes.light.warning"
        icon="warning"
      >
        <v-card-text>
          {{ $t("components.multifileupload2.file_exists_warning") }}
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="fileExistsWarning = false">
            {{ $t("globals.close") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import pdf from "vue-pdf";
import { saveAs } from "file-saver";
import AuthService from "@/services/auth.service";
import { TokenService } from "@/services/token.service";
import FilePreview from "./FilePreview.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "multi-file-upload2",
  props: [
    "id",
    "uploadMsg",
    "rules",
    "label",
    "keepRevisions",
    "fileUploadUrl",
    "zipDownloadUrl",
    "getFilesUrl",
    "ownerId",
    "categories",
    "tags",
    "groups",
    "filesIds",
    "disabled",
    "currentFolder",
    "files",
    "public",
  ],
  components: {
    pdf,
    FilePreview,
  },
  computed: {
    ...mapGetters("auth", ["user"]),
  },
  data() {
    return {
      fileItem: null,
      error: false,
      uploading: false,
      selectedFiles: [],
      internalFiles: [],
      src: null,
      showPreview: false,
      fileData: null,
      pageCount: 0,
      fileExistsWarning: false,
    };
  },
  watch: {
    files: {
      handler(v) {
        for (const f of v) {
          f.description = this.createDescription(f);
        }
        this.internalFiles = v;
      },
    },
    filesIds: {
      handler() {
        console.log(
          "multi file upload fileIds wathcer: ",
          JSON.stringify(this.filesIds)
        );
        this.getFiles();
      },
    },
    selectedFiles: {
      handler(v) {
        this.emitFiles(v);
      }
    }
  },
  mounted() {
    if (this.files !== null && this.files !== undefined) {
      for (const f of this.files) {
        f.description = this.createDescription(f);
      }
      this.internalFiles = this.files;
    }
    this.getFiles();
  },
  methods: {
    ...mapActions("documentsService", ["getFile"]),
    close() {
      this.showPreview = false;
      this.fileItem = null;
    },
    createDescription(item) {
      return (
        item.file.Name.substring(0, 10) +
        "..." +
        item.file.Name.slice(item.file.Name.length - 10) +
        "--" +
        new Date(Date.parse(item.file.DateCreated)).toLocaleString()
      );
    },
    emitFiles(data) {
      this.uploading = false;
      // for (const f of data) {
      //   delete f.description;
      // }
      this.$emit("emit-files", data);
    },
    emitUploadStart() {
      this.uploading = true;
      this.$emit("emit-upload-start");
    },
    emitUploadEnd() {
      this.uploading = false;
      this.$emit("emit-upload-end");
    },
    emitUploadError(error) {
      this.uploading = false;
      this.$emit("emit-upload-error", error);
    },
    // pdfError(error) {
    //   console.log("pdf error: ", error);
    // },
    // pdfLoaded() {
    //   console.log("pdf loaded");
    // },
    // pdfProgress(progress) {
    //   console.log("pdf progress: ", progress);
    // },
    async preview(item) {
      console.log(item.file);
      this.fileItem = {
        Id: item.file.Id,
        FileName: item.file.Name,
        FileType: item.file.ExtensionType.FileType,
      };
      this.showPreview = true;
    },
    readFileAsDataUrlAsync(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onload = () => {
          resolve(reader.result);
        };

        reader.onerror = reject;

        reader.readAsDataURL(file);
      });
    },
    readFileAsTextAsync(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result);
        };

        reader.onerror = reject;
        reader.readAsText(file);
      });
    },
    onAddClick() {
      const uploader = document.getElementById(this.id);
      if (uploader !== null && uploader !== undefined) {
        uploader.click();
      }
      // this.$refs.uploader.click();
    },
    remove(file) {
      console.log(file, this.selectedFiles[0]);
      this.selectedFiles = this.selectedFiles.filter(
        (o) => o.file.Name !== file.file.Name
      );
      this.emitFiles(this.selectedFiles);
      const uploader = document.getElementById(this.id);
      if (uploader !== null && uploader !== undefined) {
        uploader.value = "";
      }
    },
    async handleFileChange(e) {
      let displayWarning = false;
      console.log("file change: ", e);
      const files = e.target.files;
      console.log(files);
      if (!files) {
        return;
      }
      if (files.length === 0) {
        return;
      }
      try {
        const newItems = [];
        for (const file of files) {
          if (
            this.internalFiles.filter((o) => o.file.Name === file.name)
              .length === 0
          ) {
            const newItem = await this.createUploadFile(file);
            console.log(newItem);
            newItems.push(newItem);
          } else {
            displayWarning = true;
          }
        }
        console.log(newItems);
        if (newItems.length > 0) {
          console.log(newItems);
          this.emitUploadStart();
          let token = TokenService.getToken();
          const res = (await axios.post(this.fileUploadUrl, newItems, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })).data;
          for (const fileItem of res) {
            this.selectedFiles.push({ file: fileItem });
          }
          this.emitFiles(this.selectedFiles);
          if (this.internalFiles === null || this.internalFiles === undefined) {
            this.internalFiles = [];
          }
          for (const f of this.selectedFiles) {
            f.description = this.createDescription(f);
          }
          this.internalFiles = this.internalFiles.concat(this.selectedFiles);

          console.log(this.selectedFiles);
        }
      } catch (error) {
        this.emitUploadError(error);
      } finally {
        this.fileExistsWarning = displayWarning;
      }
    },
    async getFiles() {
      if (
        this.filesIds !== undefined &&
        this.filesIds !== null &&
        this.filesIds.length > 0
      ) {
        try {
          this.emitUploadStart();
          this.selectedFiles = [];
          if (this.internalFiles === null || this.internalFiles === undefined) {
            this.internalFiles = [];
          }

          const result = (await axios.post(
            `${this.getFilesUrl}`,
            this.filesIds
          )).data;

          for (const item of result) {
            const newfile = await this.makeFile(item);
            const internalItem = { file: item, File: newfile };
            internalItem.description = this.createDescription(internalItem);
            this.selectedFiles.push(internalItem);
            this.internalFiles.push(internalItem);
          }
          this.emitUploadEnd();
        } catch (error) {
          this.emitUploadError(error);
        }
      }
    },
    async makeFile(item) {
      const res = (await axios.get(`${this.fileUploadUrl}/${item.Id}`)).data;
      const blob = this.$files.b64toBlob(res);
      return new File([blob], item.Name, { type: blob.type });
    },
    async createUploadFile(file) {
      console.log(file);
      const res = await this.readFileAsDataUrlAsync(file);
      const tempFolder =
        this.currentFolder == null ? null : { Path: this.currentFolder };
      const user = await AuthService.getUser();
      console.log("USERNAME: ", this.user);
      const itemFile = {
        File: {
          OwnerId: user.profile.sub, //this.ownerId,
          Owner: { UserName: this.user },
          Name: file.name,
          FileSize: file.size,
          KeepRevisions: this.keepRevisions,
          Temporary: false,
          MarkedForDeletion: false,
          IsPublic: this.public ? true : false,
          Folder: tempFolder,
          Categories: this.categories
            ? this.categories.map((x) => ({ Name: x }))
            : null,
          Tags: this.tags ? this.tags.map((x) => ({ Name: x })) : null,
          Group: this.groups ? this.groups.map((x) => ({ Name: x })) : null,
          Locations: [],
        },
        Base64Contents: res.split(",")[1],
        // File: file,
      };

      return itemFile;
    },
    async download(item) {
      const res = await axios.get(`${this.fileUploadUrl}/${item.file.Id}`);
      const data = this.$files.b64toBlob(res.data);
      saveAs(data, item.file.Name);
    },
  },
};
</script>

<style scoped>
.text--white /deep/ label {
  color: white;
}
</style>
<style>
.chip-btn {
  margin-left: 5px !important;
}
</style>
